import {Component, EventEmitter, Input, Output, ViewContainerRef} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {ActivatedRoute, Router} from '@angular/router';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Configuration} from '../shared/services/configuration';
import {HttpClientCustom} from '../shared/services/http.client';
import * as _ from 'underscore';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';
import {FormBuilder} from '@angular/forms';
import {Auth} from '../shared/services/auth';
import {Location} from '@angular/common';
import {isString} from 'util';
import {SharedData} from '../shared/sharedData';
import {ToasterComponent} from '../toasterComponent/toasterComponent';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'AddEmpType',
  templateUrl: 'addEmpType.html'
})
export class AddEmployementTypeComponent {
  @Input('parentOrg')
  public parentOrg: any;
  @Output() public addOrgEvent = new EventEmitter();

  public data: any;
  public empTypedata: any = {};
  public _baseUrl: any;
  public type: any = 'ADD';
  public categoryModel: any;
  public empPresent: boolean = false;

  constructor(
    public route: ActivatedRoute,
    public modalService: NgbModal,
    public _global: Configuration,
    public http: HttpClientCustom,
    public _sanitizer: DomSanitizer,
    public builder: FormBuilder,
    public _auth: Auth,
    public router: Router,
    public _location: Location,
    public share: SharedData,
    public _toaster: ToasterComponent,
    public translate: TranslateService,
    vcr: ViewContainerRef) {
    this._baseUrl = _global.get('EPMS_BASE_URL');
    let data: any = this.share.getData();
    if (_.isEmpty(data)) {
      this._location.back();
    } else {
      if (data.type === 'ADD') {
        this.data = {};
        this.type = 'ADD';
      } else if (data.type === 'EDIT') {
        this.empTypedata = data.empTypedata;
        this.type = 'EDIT';
      } else {
        this.empTypedata = data.empTypedata;
        this.type = 'DELETE';
        let url = this._baseUrl + 'v1/webAdmin/category/check/' + this.empTypedata.id;
        this.http.get(url).subscribe((result) => {
          if (result.success) {
            this.empPresent = true;
          } else {
            this.empPresent = false;
          }
        });
      }
    }

    this._toaster.setViewRef(vcr);
  }

  // when auto-complete value is selected this method fires and payload create
  public gotNewValue(e, type) {
    this.categoryModel = e;
  }

  // Formatter
  public nameValueFormatter(data: any): string {
    return `${data.type}`+`(${data.code})`;
  }

  public autoCompleteListCategoryFormatter = (data: any): SafeHtml => {
    let html = `<span>${data.type}(${data.code})</span>`;
    return this._sanitizer.bypassSecurityTrustHtml(html);
  }

  // to get list of designation based on keyword
  public categoryObservableSource = (keyword: any): Observable<any[]> => {
    let url = this._baseUrl + 'v1/webAdmin/category/categorySearch';
    url += '?searchString=' + keyword + '&id=' + this.empTypedata.id;
    if (keyword.trim()) {
      return this.http.get(url)
        .map((res) => {
          return res;
        }, (error) => {
          return Observable.of([]);
        });
    } else {
      return Observable.of([]);
    }
  }

  // navigate back
  public goToBackPage() {
    this._location.back();
  }

  public isEmpty(val) {
    return !val
      || (isString(val) && !val.trim());
  }

  public saveCategory() {
    if (this.validateEmployeetype()) {
      let url = this._baseUrl + 'v1/webAdmin/category/save';
      this.http.post(url, this.empTypedata).subscribe((result) => {
        if (result.success) {
          this.translate.get('jobCatSaved').subscribe((msg) => {
            this._toaster.showSuccess(msg);
          });
          setTimeout(() => this.goToBackPage(), 1000);
        } else {
          this.translate.get(result.errorMessages[0]).subscribe((msg) => {
            this._toaster.showError(msg);
          });
        }
      }, (error) => {
        this.translate.get('errorWhileSavingJobCategory').subscribe((msg) => {
          this._toaster.showError(msg);
        });
      });
    }
  }

  public deleteCategory() {
    if (this.empPresent && this.isEmpty(this.categoryModel)) {
      this.translate.get('pleaseSelectAlternateEmploymentJobCategoryToContinue').subscribe((msg)=>{
        this._toaster.showError(msg);
        return false;
      })
    
    }
    let url;
    if (this.empPresent) {
      url = this._baseUrl + 'v1/webAdmin/category/' + this.empTypedata.id + '?alternateId' +
        this.categoryModel.id;
    } else {
      url = this._baseUrl + 'v1/webAdmin/category/' + this.empTypedata.id;
    }
    this.http.delete(url).subscribe((result) => {
      if (result.success) {
        this.translate.get('jobCatDeleted').subscribe((msg) => {
          this._toaster.showSuccess(msg);
        });
        setTimeout(() => this.goToBackPage(), 500);
      } else {
        for (let val of result.errorMessages) {
          this.translate.get(val).subscribe((msg) => {
            this._toaster.showSuccess(msg);
          });
        }
      }
    }, (error) => {
      this.translate.get('errorWhileDeletingJobCategory').subscribe((msg) => {
        this._toaster.showError(msg);
      });
    });
  }

  public validateEmployeetype() {
    if (!this.empTypedata.code || !this.empTypedata.code.trim()) {
      this.translate.get('pleaseEnterCodeToContinue').subscribe((msg)=>{
        this._toaster.showError(msg);
      return false;
      })
      
    }
    if (!this.empTypedata.type || !this.empTypedata.type.trim()) {
      this.translate.get('enterJobCatToContinue').subscribe((msg) => {
        this._toaster.showError(msg);
      });
      return false;
    }
    if (!this.empTypedata.level || this.empTypedata.level < 1) {
      this.translate.get('pleaseEnterLevelGreaterThanZero').subscribe((msg) => {
        this._toaster.showError(msg);
      });
      return false;
    }
    if (this.empTypedata.level > 100) {
      this.translate.get('pleaseEnterLevelLessHund').subscribe((msg) => {
        this._toaster.showError(msg);
      });
      return false;
    }
    return true;
  }

}



// WEBPACK FOOTER //
// ./src/app/tools/addEmpType.ts